import binary from "../common/binary";

export default() => {
  binary();
}